var path = '/password/reset-confirmation/reset-confirmation.html';
var html = "<md-card class=has-circle-icon> <md-card-header> <md-card-header-text> <h1 class=\"md-title circle-icon email\">{{::route.title}}</h1> <p class=md-subhead> <nobr>We’ve sent instructions on how to reset your password.</nobr> <nobr>If you don’t see it in your inbox check your spam folder too.</nobr> </p> </md-card-header-text> </md-card-header> <md-card-content class=only-buttons> <div layout=row layout-align=center> <md-button class=\"md-primary md-raised return-to-login\" flex=100 flex-gt-xs=50 ng-href=/ data-test-id=accounts_reset_confirmation_login> Return to login </md-button> </div> </md-card-content> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./password/reset-confirmation/reset-confirmation.html
// module id = 111
// module chunks = 0